<template>
  <ul v-if="!noneView && farmId" class="menu-nav text-center">
    <router-link
      :to="'/smartfarm/' + farmId +'/dashboard'"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="flaticon-squares-1"></i>
          <span class="menu-text">{{ i18n.dashboard }}</span>
        </a>
      </li>
    </router-link>

    <li
      v-if="!isMobile"
      aria-haspopup="true"
      class="menu-item menu-item-submenu"
      v-bind:class="{'menu-item-open': subOpen.info}"
      @mouseenter="openSubMenu('info')"
      @mouseleave="startCloseTimer('info')"
    >
      <a href="javascript:;" class="menu-link menu-toggle" @click.prevent="toggleSubMenuClick('info')">
        <i class="fas fa-clipboard"></i>
        <span class="menu-text"> {{ i18n.farm.info }} </span>
      </a>
      <div class="menu-submenu menu-submenu-fixed" :style="{ display: subOpen.info ? 'block' : 'none' }">
        <div class="menu-subnav megamenu" style="max-width: 1000px;">
          <ul class="menu-content">
            <router-link
              :to="'/smartfarm/' + farmId +'/detail'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                  <i class="menu-bullet menu-bullet-dot farm-mobile-dot"><span></span></i>
                  <span class="menu-text text-white font-weight-bold font-size-lg"> {{ i18n.farm.search }} </span>
                </a>
              </li>
            </router-link>

            <router-link
              :to="'/smartfarm/' + farmId +'/setting'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                  <i class="menu-bullet menu-bullet-dot farm-mobile-dot"><span></span></i>
                  <span class="menu-text text-white font-weight-bold font-size-lg"> {{ i18n.farm.cultivationEnvControl }} </span>
                </a>
              </li>
            </router-link>

            <router-link
              :to="'/smartfarm/' + farmId +'/crops'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                  <i class="menu-bullet menu-bullet-dot farm-mobile-dot"><span></span></i>
                  <span class="menu-text text-white font-weight-bold font-size-lg"> {{ i18n.farm.cultivationCropMangement }} </span>
                </a>
              </li>
            </router-link>
            <router-link
              :to="'/smartfarm/' + farmId +'/farm-photo-registration'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                  <i class="menu-bullet menu-bullet-dot farm-mobile-dot"><span></span></i>
                  <span class="menu-text text-white font-weight-bold font-size-lg"> {{ i18n.farm.farmPhotoRegistration }} </span>
                </a>
              </li>
            </router-link>
          </ul>
        </div>
      </div>
    </li>
    <li
      v-else
      aria-haspopup="true"
      class="menu-item menu-item-submenu"
      v-bind:class="{'menu-item-open': subOpen.info}"
    >
      <a href="javascript:;" class="menu-link" @click.prevent.stop="toggleSubMenuClick('info', $event)">
        <i class="fas fa-clipboard"></i>
        <span class="menu-text"> {{ i18n.farm.info }} </span>
      </a>
      <div class="menu-submenu menu-submenu-fixed" :style="{ display: subOpen.info ? 'block' : 'none' }">
        <div class="menu-subnav megamenu" style="max-width: 1000px;">
          <ul class="menu-content">
            <router-link
              :to="'/smartfarm/' + farmId +'/detail'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                  <i class="menu-bullet menu-bullet-dot farm-mobile-dot"><span></span></i>
                  <span class="menu-text text-white font-weight-bold font-size-lg"> {{ i18n.farm.search }} </span>
                </a>
              </li>
            </router-link>

            <router-link
              :to="'/smartfarm/' + farmId +'/setting'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                  <i class="menu-bullet menu-bullet-dot farm-mobile-dot"><span></span></i>
                  <span class="menu-text text-white font-weight-bold font-size-lg"> {{ i18n.farm.cultivationEnvControl }} </span>
                </a>
              </li>
            </router-link>

            <router-link
              :to="'/smartfarm/' + farmId +'/crops'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                  <i class="menu-bullet menu-bullet-dot farm-mobile-dot"><span></span></i>
                  <span class="menu-text text-white font-weight-bold font-size-lg"> {{ i18n.farm.cultivationCropMangement }} </span>
                </a>
              </li>
            </router-link>
            <router-link
              :to="'/smartfarm/' + farmId +'/farm-photo-registration'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                  <i class="menu-bullet menu-bullet-dot farm-mobile-dot"><span></span></i>
                  <span class="menu-text text-white font-weight-bold font-size-lg"> {{ i18n.farm.farmPhotoRegistration }} </span>
                </a>
              </li>
            </router-link>
          </ul>
        </div>
      </div>
    </li>
    <!-- 팜 실적 - Desktop -->
    <li
      v-if="!isMobile"
      aria-haspopup="true"
      class="menu-item menu-item-submenu"
      v-bind:class="{'menu-item-open': subOpen.management}"
      @mouseenter="openSubMenu('management')"
      @mouseleave="startCloseTimer('management')"
    >
      <a href="javascript:;" class="menu-link menu-toggle" @click.prevent="toggleSubMenuClick('management')">
        <i class="fas fa-clipboard"></i>
        <span class="menu-text"> {{ i18n.farm.farmYield }} </span>
      </a>
      <div class="menu-submenu menu-submenu-fixed" :style="{ display: subOpen.management ? 'block' : 'none' }">
        <div class="menu-subnav megamenu" style="max-width: 1000px;">
          <ul class="menu-content">
            <router-link
              :to="'/smartfarm/' + farmId +'/yield-management'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                  <i class="menu-bullet menu-bullet-dot farm-mobile-dot"><span></span></i>
                  <span class="menu-text text-white font-weight-bold font-size-lg"> {{ i18n.farm.yieldPlanInfo }} </span>
                </a>
              </li>
            </router-link>
            <router-link
              :to="'/smartfarm/' + farmId +'/environment-measurement-information'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                  <i class="menu-bullet menu-bullet-dot farm-mobile-dot"><span></span></i>
                  <span class="menu-text text-white font-weight-bold font-size-lg"> {{ i18n.farm.EnvMeasurementInfo }} </span>
                </a>
              </li>
            </router-link>
            <router-link
              :to="'/smartfarm/' + farmId +'/farm-calendar'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                  <i class="menu-bullet menu-bullet-dot farm-mobile-dot"><span></span></i>
                  <span class="menu-text text-white font-weight-bold font-size-lg"> {{ i18n.farm.farmCalendar }} </span>
                </a>
              </li>
            </router-link>
          </ul>
        </div>
      </div>
    </li>
    <!-- 팜 실적 - Mobile -->
    <li
      v-else
      aria-haspopup="true"
      class="menu-item menu-item-submenu"
      v-bind:class="{'menu-item-open': subOpen.management}"
    >
      <a href="javascript:;" class="menu-link" @click.prevent.stop="toggleSubMenuClick('management', $event)">
        <i class="fas fa-clipboard"></i>
        <span class="menu-text"> {{ i18n.farm.farmYield }} </span>
      </a>
      <div class="menu-submenu menu-submenu-fixed" :style="{ display: subOpen.management ? 'block' : 'none' }">
        <div class="menu-subnav megamenu" style="max-width: 1000px;">
          <ul class="menu-content">
            <router-link
              :to="'/smartfarm/' + farmId +'/yield-management'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                  <i class="menu-bullet menu-bullet-dot farm-mobile-dot"><span></span></i>
                  <span class="menu-text text-white font-weight-bold font-size-lg"> {{ i18n.farm.yieldPlanInfo }} </span>
                </a>
              </li>
            </router-link>
            <router-link
              :to="'/smartfarm/' + farmId +'/environment-measurement-information'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                  <i class="menu-bullet menu-bullet-dot farm-mobile-dot"><span></span></i>
                  <span class="menu-text text-white font-weight-bold font-size-lg"> {{ i18n.farm.EnvMeasurementInfo }} </span>
                </a>
              </li>
            </router-link>
            <router-link
              :to="'/smartfarm/' + farmId +'/farm-calendar'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
                <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                  <i class="menu-bullet menu-bullet-dot farm-mobile-dot"><span></span></i>
                  <span class="menu-text text-white font-weight-bold font-size-lg"> {{ i18n.farm.farmCalendar }} </span>
                </a>
              </li>
            </router-link>
          </ul>
        </div>
      </div>
    </li>
    <!-- 분석 - Desktop -->
    <li
      v-if="!isMobile"
      aria-haspopup="true"
      class="menu-item menu-item-submenu"
      v-bind:class="{'menu-item-open': subOpen.analysis}"
      @mouseenter="openSubMenu('analysis')"
      @mouseleave="startCloseTimer('analysis')"
    >
      <a href="javascript:;" class="menu-link menu-toggle" @click.prevent="toggleSubMenuClick('analysis')">
        <i class="fas fa-clipboard"></i>
        <span class="menu-text"> {{ i18n.farm.analysis }} </span>
      </a>
      <div class="menu-submenu menu-submenu-fixed" :style="{ display: subOpen.analysis ? 'block' : 'none' }">
        <div class="menu-subnav megamenu" style="max-width: 1000px;">
          <ul class="menu-content">
            <router-link
              :to="'/smartfarm/' + farmId +'/time-series'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
              <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                <i class="menu-bullet menu-bullet-dot farm-mobile-dot"></i>
                <span class="menu-text text-white font-weight-bold font-size-lg">{{ i18n.farm.timeSeriesInfo }} </span>
              </a>
            </li>
            </router-link>
            <router-link
              :to="'/smartfarm/' + farmId +'/alert-log-time-series'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
              <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                <i class="menu-bullet menu-bullet-dot farm-mobile-dot"></i>
                <span class="menu-text text-white font-weight-bold font-size-lg"> {{  i18n.farm.alertLogTimeSeriesInfo }} </span>
              </a>
            </li>
            </router-link>
            <router-link
              :to="'/smartfarm/' + farmId +'/notification-action'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
              <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                <i class="menu-bullet menu-bullet-dot farm-mobile-dot"></i>
                <span class="menu-text text-white font-weight-bold font-size-lg"> {{  i18n.farm.farmDeviationStatusInfo }} </span>
              </a>
            </li>
            </router-link>
            <router-link
              :to="'/smartfarm/' + farmId +'/weekly-report'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
              <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                <i class="menu-bullet menu-bullet-dot farm-mobile-dot"></i>
                <span class="menu-text text-white font-weight-bold font-size-lg"> {{  i18n.farm.weeklyreport }} </span>
              </a>
            </li>
            </router-link>
          </ul>
        </div>
      </div>
    </li>
    <!-- 분석 - Mobile -->
    <li
      v-else
      aria-haspopup="true"
      class="menu-item menu-item-submenu"
      v-bind:class="{'menu-item-open': subOpen.analysis}"
    >
      <a href="javascript:;" class="menu-link" @click.prevent.stop="toggleSubMenuClick('analysis', $event)">
        <i class="fas fa-clipboard"></i>
        <span class="menu-text"> {{ i18n.farm.analysis }} </span>
      </a>
      <div class="menu-submenu menu-submenu-fixed" :style="{ display: subOpen.analysis ? 'block' : 'none' }">
        <div class="menu-subnav megamenu" style="max-width: 1000px;">
          <ul class="menu-content">
            <router-link
              :to="'/smartfarm/' + farmId +'/time-series'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
              <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                <i class="menu-bullet menu-bullet-dot farm-mobile-dot"></i>
                <span class="menu-text text-white font-weight-bold font-size-lg">{{ i18n.farm.timeSeriesInfo }} </span>
              </a>
            </li>
            </router-link>
            <router-link
              :to="'/smartfarm/' + farmId +'/alert-log-time-series'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
              <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                <i class="menu-bullet menu-bullet-dot farm-mobile-dot"></i>
                <span class="menu-text text-white font-weight-bold font-size-lg"> {{  i18n.farm.alertLogTimeSeriesInfo }} </span>
              </a>
            </li>
            </router-link>
            <router-link
              :to="'/smartfarm/' + farmId +'/notification-action'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
              <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                <i class="menu-bullet menu-bullet-dot farm-mobile-dot"></i>
                <span class="menu-text text-white font-weight-bold font-size-lg"> {{  i18n.farm.farmDeviationStatusInfo }} </span>
              </a>
            </li>
            </router-link>
            <router-link
              :to="'/smartfarm/' + farmId +'/weekly-report'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
              <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                <i class="menu-bullet menu-bullet-dot farm-mobile-dot"></i>
                <span class="menu-text text-white font-weight-bold font-size-lg"> {{  i18n.farm.weeklyreport }} </span>
              </a>
            </li>
            </router-link>
          </ul>
        </div>
      </div>
    </li>

    <!-- 도움말 - Desktop -->
    <li
      v-if="!isMobile"
      aria-haspopup="true"
      class="menu-item menu-item-submenu"
      v-bind:class="{'menu-item-open': subOpen.help}"
      @mouseenter="openSubMenu('help')"
      @mouseleave="startCloseTimer('help')"
    >
      <a href="javascript:;" class="menu-link menu-toggle" @click.prevent="toggleSubMenuClick('help')">
        <i class="fas fa-clipboard"></i>
        <span class="menu-text"> {{ i18n.farm.help }} </span>
      </a>
      <div class="menu-submenu menu-submenu-fixed" :style="{ display: subOpen.help ? 'block' : 'none' }">
        <div class="menu-subnav megamenu" style="max-width: 1000px;">
          <ul class="menu-content">
            <router-link
              :to="'/smartfarm/' + farmId +'/as'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
              <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                <i class="menu-bullet menu-bullet-dot farm-mobile-dot"></i>
                <span class="menu-text text-white font-weight-bold font-size-lg"> {{ i18n.claim }} </span>
              </a>
            </li>
            </router-link>
            <router-link
              :to="'/smartfarm/' + farmId +'/faq'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
              <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                <i class="menu-bullet menu-bullet-dot farm-mobile-dot"></i>
                <span class="menu-text text-white font-weight-bold font-size-lg"> {{ i18n.faq }} </span>
              </a>
            </li>
            </router-link>
          </ul>
        </div>
      </div>
    </li>
    <!-- 도움말 - Mobile -->
    <li
      v-else
      aria-haspopup="true"
      class="menu-item menu-item-submenu"
      v-bind:class="{'menu-item-open': subOpen.help}"
    >
      <a href="javascript:;" class="menu-link" @click.prevent.stop="toggleSubMenuClick('help', $event)">
        <i class="fas fa-clipboard"></i>
        <span class="menu-text"> {{ i18n.farm.help }} </span>
      </a>
      <div class="menu-submenu menu-submenu-fixed" :style="{ display: subOpen.help ? 'block' : 'none' }">
        <div class="menu-subnav megamenu" style="max-width: 1000px;">
          <ul class="menu-content">
            <router-link
              :to="'/smartfarm/' + farmId +'/as'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
              <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                <i class="menu-bullet menu-bullet-dot farm-mobile-dot"></i>
                <span class="menu-text text-white font-weight-bold font-size-lg"> {{ i18n.claim }} </span>
              </a>
            </li>
            </router-link>
            <router-link
              :to="'/smartfarm/' + farmId +'/faq'"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li
                aria-haspopup="true"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
                ]"
              >
              <a :href="href" class="menu-link" @click="(e) => { navigate(e); closeAllMenus(); }">
                <i class="menu-bullet menu-bullet-dot farm-mobile-dot"></i>
                <span class="menu-text text-white font-weight-bold font-size-lg"> {{ i18n.faq }} </span>
              </a>
            </li>
            </router-link>
          </ul>
        </div>
      </div>
    </li>

    <router-link
      :to="'/smartfarm/' + farmId +'/notice'"
      v-slot="{ href, navigate }"
    >
    <li
      aria-haspopup="true"
      data-menu-toggle="click"
      class="menu-item menu-item-submenu menu-item-open-dropdown"
      v-bind:class="{ 'menu-item-active': hasActiveChildren('notice') }"
    >
      <a :href="href" class="menu-link" @click="navigate">
        <i class="fas fa-flag"></i>
        <span class="menu-text"> {{ i18n.notice }} </span>
      </a>
    </li>
    </router-link>
  </ul>
</template>

<script>
import {mapGetters} from 'vuex';
import i18n from '@/core/plugins/vue-i18n.js';

export default {
  name: 'KTMenu',
  computed: {
    ...mapGetters(['farmId']),
    noneView() {
      return this.$route.path.startsWith('/portal') || this.$route.path.startsWith('/profile');
    }
  },
  data() {
    return {
      i18n: {
        dashboard: i18n.t('dashboard.title'),
        farm: {
          info: i18n.t('topNavBar.farm.info'),
          farmYield: i18n.t('topNavBar.farm.farmYield'),
          analysis: i18n.t('topNavBar.farm.analysis'),
          help: i18n.t('topNavBar.farm.help'),
          search: i18n.t('topNavBar.farm.search'),
          cropManagement :  i18n.t('topNavBar.farm.cropManagement'),
          yieldInfo : i18n.t('topNavBar.farm.yieldInfo'),
          yieldPlanInfo : i18n.t('topNavBar.farm.yieldPlanInfo'),
          EnvMeasurementInfo: i18n.t('topNavBar.farm.EnvMeasurementInfo'),
          farmCalendar: i18n.t('topNavBar.farm.farmCalendar'),
          farmPhotoRegistration: i18n.t('topNavBar.farm.farmPhotoRegistration'),
          timeSeriesInfo: i18n.t('topNavBar.farm.timeSeriesInfo'),
          alertLogTimeSeriesInfo: i18n.t('topNavBar.farm.alertLogTimeSeriesInfo'),
          farmDeviationStatusInfo: i18n.t('topNavBar.farm.farmDeviationStatusInfo'),
          weeklyreport: i18n.t('topNavBar.farm.weeklyreport'),
          cultivationEnvControl: i18n.t('topNavBar.farm.cultivationEnvControl'),
          cultivationCropMangement: i18n.t('topNavBar.farm.cultivationCropMangement'),
        },
        claim: i18n.t('topNavBar.claim'),
        faq: i18n.t('topNavBar.faq'),
        notice: i18n.t('topNavBar.notice'),
      },
      subOpen: {
        info: false,
        management: false,
        analysis: false,
        help: false,
      },
      clickedOpen: {
        info: false,
        management: false,
        analysis: false,
        help: false,
      },
      closeTimers: {
        info: null,
        management: null,
        analysis: null,
        help: null,
      },
      isMobile: false
    }
  },
  mounted() {
    // 모바일 여부 확인
    this.checkIsMobile();
    window.addEventListener('resize', this.checkIsMobile);
  },
  destroyed() {
    // 컴포넌트 파괴 시 모든 타이머 정리
    Object.keys(this.closeTimers).forEach(key => {
      if (this.closeTimers[key]) {
        clearTimeout(this.closeTimers[key]);
      }
    });
    window.removeEventListener('resize', this.checkIsMobile);
  },
  methods: {
    checkIsMobile() {
      // 768px 이하를 모바일로 간주 (Bootstrap의 md breakpoint)
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 768;

      // 모바일 상태가 변경되면 모든 메뉴 닫기
      if (wasMobile !== this.isMobile) {
        Object.keys(this.subOpen).forEach(key => {
          this.subOpen[key] = false;
          this.clickedOpen[key] = false;
        });
      }
    },
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
    // 호버로 메뉴 열기
    openSubMenu(menuName) {
      // 모바일에서는 호버 이벤트 무시
      if (this.isMobile) {
        return;
      }
      // 타이머가 있으면 취소
      if (this.closeTimers[menuName]) {
        clearTimeout(this.closeTimers[menuName]);
        this.closeTimers[menuName] = null;
      }
      // 클릭으로 열린 상태가 아니면 호버로 열기
      if (!this.clickedOpen[menuName]) {
        // 다른 메뉴들 닫기
        this.closeOtherMenus(menuName);
        this.subOpen[menuName] = true;
      }
    },
    // 호버 벗어났을 때 닫기 타이머 시작
    startCloseTimer(menuName) {
      // 모바일에서는 호버 이벤트 무시
      if (this.isMobile) {
        return;
      }
      // 클릭으로 열린 상태가 아니면 타이머로 닫기
      if (!this.clickedOpen[menuName]) {
        this.closeTimers[menuName] = setTimeout(() => {
          this.subOpen[menuName] = false;
        }, 300); // 300ms 후 닫기
      }
    },
    // 클릭으로 토글
    toggleSubMenuClick(menuName, event) {
      // 이벤트 전파 중지 - Metronic의 linkClick 이벤트가 발생하지 않도록
      if (event) {
        event.stopPropagation();
      }

      // 타이머가 있으면 먼저 취소
      if (this.closeTimers[menuName]) {
        clearTimeout(this.closeTimers[menuName]);
        this.closeTimers[menuName] = null;
      }

      // 클릭 상태 토글
      this.clickedOpen[menuName] = !this.clickedOpen[menuName];
      this.subOpen[menuName] = this.clickedOpen[menuName];

      // 열릴 때 다른 메뉴들 닫기
      if (this.clickedOpen[menuName]) {
        this.closeOtherMenus(menuName);
      }
    },
    // 하위 메뉴 항목 클릭 시 모든 메뉴 닫기
    closeAllMenus() {
      // 모바일에서는 메뉴 상태를 유지하고, 데스크톱에서만 메뉴를 닫음
      if (this.isMobile) {
        return;
      }

      const menuNames = ['info', 'management', 'analysis', 'help'];
      menuNames.forEach(menuName => {
        // 타이머 취소
        if (this.closeTimers[menuName]) {
          clearTimeout(this.closeTimers[menuName]);
          this.closeTimers[menuName] = null;
        }
        // 메뉴 닫기
        this.subOpen[menuName] = false;
        this.clickedOpen[menuName] = false;
      });
    },
    // 다른 메뉴들 닫기
    closeOtherMenus(currentMenu) {
      const menuNames = ['info', 'management', 'analysis', 'help'];
      menuNames.forEach(menuName => {
        if (menuName !== currentMenu) {
          // 타이머 취소
          if (this.closeTimers[menuName]) {
            clearTimeout(this.closeTimers[menuName]);
            this.closeTimers[menuName] = null;
          }
          // 메뉴 닫기
          this.subOpen[menuName] = false;
          this.clickedOpen[menuName] = false;
        }
      });
    },
    toggleSubMenu(toggleNm){
      this.subOpen[toggleNm] = !this.subOpen[toggleNm]
      this.pushFirstSubMenu(toggleNm)
    },
    pushFirstSubMenu(toggleNm) {
      if (toggleNm === 'info') {
        if (this.$route.path.split('/').slice(-1)[0] !== 'detail'){
          this.$router.push('/smartfarm/' + this.farmId +'/detail')
        }
      } else if (toggleNm === 'analysis') {
        if (this.$route.path.split('/').slice(-1)[0] !== 'time-series'){
          this.$router.push('/smartfarm/' + this.farmId +'/time-series')
        }
      } else if (toggleNm === 'management') {
        if (this.$route.path.split('/').slice(-1)[0] !== 'yield-management'){
          this.$router.push('/smartfarm/' + this.farmId +'/yield-management')
        }
      } else if (toggleNm === 'help') {
        if (this.$route.path.split('/').slice(-1)[0] !== 'as'){
          this.$router.push('/smartfarm/' + this.farmId +'/as')
        }
      }

    }
  },
  beforeDestroy() {
    // 컴포넌트 파괴 시 모든 타이머 정리
    Object.keys(this.closeTimers).forEach(key => {
      if (this.closeTimers[key]) {
        clearTimeout(this.closeTimers[key]);
      }
    });
  },
};
</script>